import { render, staticRenderFns } from "./ContextSubmenu.vue?vue&type=template&id=1c24071d&"
import script from "./ContextSubmenu.vue?vue&type=script&lang=js&"
export * from "./ContextSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports